import { fields } from 'constants/fieldTypes';
import moment from 'moment';
import { agentEmailKey } from "../pages/quotation"
const CryptoJS = require("crypto-js");

export function getUrl(opciones_servicio, formResponses, service, form) {
    if (opciones_servicio) {
        let zipCodeEmpty = false;
        const opcionesServicio = JSON.parse(opciones_servicio);
        const url = new URL(opcionesServicio.url);
        const params = new URLSearchParams(url.search.slice(1));
        let urlBase = new URL(url.origin + url.pathname);
        for (let p of params) {
            let field = formResponses.find(item => item.key === String((MapKeysUrl[p[0]] ? MapKeysUrl[p[0]] : p[0])));
            if (!field) {
                field = formResponses.find(item => item.code === String((MapKeysUrl[p[0]] ? MapKeysUrl[p[0]] : p[0])));
            }
            let idTipoPersona = '';
            if (!field || !field.value) {
                field = formResponses.find(item => item.key === (p[0]));
                if (opcionesServicio && opcionesServicio.key && opcionesServicio.key === "cpFacturacion") {
                    field = formResponses.find(item => item.key === (opcionesServicio.key));
                }
                if (!field && (p[0] === "tipoIdentificadorPersona" || p[0] === "typeLegalId")) {
                    const tipoDePersonaAsegurado = formResponses.find(item => item.key === ("tipoDePersonaAsegurado"))?.value;
                    const tipoDePersonaContratante = formResponses.find(item => item.key === ("tipoDePersonaContratante"))?.value;
                    const tipoDePersona = opcionesServicio.key === 'Asegurado' ? tipoDePersonaAsegurado : tipoDePersonaContratante;
                    idTipoPersona = p[0] === "tipoIdentificadorPersona" ? 1 : tipoDePersona ? tipoDePersona === "personaFisica" ? 1 : 2 :
                        tipoDePersonaContratante ? tipoDePersonaContratante === "personaFisica" ? 1 : 2 : idTipoPersona;
                }
                if (!field && p[0] === "tipoInmueble") {
                    const tipoInmueble = formResponses.find(item => item.key === ("tipoInmueble"))?.value;
                    idTipoPersona = tipoInmueble;
                }
            }

            const aditionalRadios = formResponses.find(x => x.key === 'aditionals')?.active;
            let aditionalValue = null
            if (aditionalRadios && (MapKeysUrl[p[0]] === 'FHM' || MapKeysUrl[p[0]] === 'TEV')) {
                aditionalValue = aditionalRadios[MapKeysUrl[p[0]]];
            }

            let value = p[1] && p[1] !== 'value' ? idTipoPersona ? idTipoPersona : p[1] :
                aditionalValue !== null ? aditionalValue :
                    field && (field.value || field.value >= 0) ? field.value :
                        field && Number(field.value) >= 0 && field.code ? Number(field.value) : 0;

            if (field && field.code && form) {
                value = field && field.value === 0 ? 0 : getSublimitOrValue(field, formResponses) ? field.value : 0;
            }
            if (fieldRFC.includes(p[0]) && !value) {
                value = formResponses.find(x => x.key === p[0])?.value || form && form.getValueField([p[0]])
            }
            if (service && service === 'calculator' && p[0] === 'propertyType') {
                value = value === '01' ? 'Propio' : 'Arrendado';
            }
            const newParam = NewKeysUrl[p[0]] || p[0];

            if (urlBase.searchParams.get(newParam)) {
                (value || value >= 0) && urlBase.searchParams.set(newParam, value);
            } else {
                (value || value >= 0) && urlBase.searchParams.append(newParam, value);
            }

            const zipCode = opcionesServicio.url && opcionesServicio.url.includes('zip-code');
            if (zipCode && p[0] && p[0].includes('Contratante') && NewKeysUrl[p[0]] === 'codigoPostal' && !value) {
                zipCodeEmpty = true
            }
        }

        const newUrl = opcionesServicio.key ? urlBase.href.replace(opcionesServicio.key, '') : urlBase.href;
        opcionesServicio.url = zipCodeEmpty ? null : newUrl;
        return opcionesServicio
    }
}

export const setFieldsValue = (key, value, field, formResponses, form) => {
    const iField = formResponses.findIndex(x => x.key === key);
    const indexField = iField === -1 ? formResponses.findIndex(x => x.code === key) : iField;
    if (field) { field['value'] = value; }
    indexField !== -1 ? formResponses[indexField].value = value : formResponses.push(field ? field : { key: key, value: value });
    form && form.setFieldsValue({ [key]: value })
}

const getSituations = (sJsonIssue, sPolicy) => {
    let newJsonIssue = [];
    sJsonIssue && sJsonIssue.forEach(item => {
        const situation = sPolicy && sPolicy.find(x => x.numberSituation === item.riskNumber);
        const newCoverages = situation && situation.coverages.map(val => ({
            coverageId: val.coverageId,
            amountSumInsurance: val.insuredAmount
        }));
        newJsonIssue = [...newJsonIssue, { ...item, coverages: newCoverages }];
    });
    return newJsonIssue
}

export function getBodyRedirect(jsonIssue, policy, infoRequote, formResponses) {
    const policyM = jsonIssue && jsonIssue.policy;
    const configuration = {
        ...jsonIssue.configuration, channel: !policyM.userId ? "directo" : "agente",
        product: "PES", folioFromPartner: jsonIssue.configuration.folioFromPartner
    };
    const personalData = jsonIssue && jsonIssue.client && jsonIssue.client.personalData;
    const emailAgent = getValueField(agentEmailKey, formResponses);
    const user = personalData && ({
        name: policyM.name ? policyM.name : '',
        email: emailAgent ? emailAgent : policyM.email ? policyM.email : '',
        phone: ''
    })
    const newPolicy = {
        currency: policyM && policyM.currencyId ? policyM.currencyId : 'MXN', periodicity: "", formPayment: "",
        costs: infoRequote.costs,
        quote: infoRequote.policy
    }

    const situation = Object.assign(jsonIssue.situation, jsonIssue.insured.address)
    const preferentialBeneficiary = jsonIssue.preferentialBeneficiary;
    const validatePB = preferentialBeneficiary && preferentialBeneficiary.personalData &&
        preferentialBeneficiary.personalData.businessName;
    const coverages = infoRequote.situations[0].coverages && infoRequote.situations[0].coverages.map(coverage => ({ ...coverage, ['insuredSum']: coverage.insuredAmount }))
    const jsonIssueM = {
        _id: jsonIssue._id,
        key: jsonIssue.key,
        configuration: configuration,
        policy: policyM,
        situation: situation,
        formPayment: jsonIssue.formPayment,
        insured: jsonIssue.insured,
        client: jsonIssue.client,
        preferentialBeneficiary: validatePB && preferentialBeneficiary ? preferentialBeneficiary : null,
        coverages: coverages,
        form: jsonIssue.form,
        polizaCotizacion: infoRequote.policy
    }
    return {
        configuration, user, policy: newPolicy, jsonIssue: jsonIssueM,
    }
}

const getSublimitOrValue = (coverage, formResponses) => {
    let sum = 0
    const index = coverage && coverage.index >= 0 && Number(coverage.index) ? Number(coverage.index) : 0
    const currencyLimit = coverage && coverage.currencyLimit && coverage.currencyLimit[index];
    currencyLimit && currencyLimit.insuredSumCriteria && currencyLimit.insuredSumCriteria.dependencies
        && currencyLimit.insuredSumCriteria.dependencies.forEach((key) => {
            const valueCovDependency = formResponses.find(x => x.code === key)?.value;
            sum = sum + (valueCovDependency >= 0 ? getPrice(Number(valueCovDependency)) : 0);
        })
    const formula = currencyLimit && currencyLimit.insuredSumCriteria && currencyLimit.insuredSumCriteria.formula && currencyLimit.insuredSumCriteria.formula.replace(/[SUM({dependencias})]{19}|[EQ({dependencias})]{18}/g, sum);
    const subLimit = formula && eval(formula);
    let valueField = Math.floor(subLimit);
    return currencyLimit && currencyLimit.insuredSumCriteria ? valueField : coverage.value;
}

export function getBody(body, model, formResponses, insureds, user, form) {
    const bodyValues = Object.keys(body).length;
    if (model) {
        const copyModel = JSON.parse(JSON.stringify(model));
        if (bodyValues == 0) {
            Object.keys(copyModel).forEach(key1 => {
                switch (key1) {
                    case 'policy':
                        const policyKeys = Object.keys(copyModel[key1] ? copyModel[key1] : {});
                        const newPolicy = {};
                        policyKeys && policyKeys.forEach(pKey => {
                            let kValue = user[newKeySituations[2][pKey]] ? user[newKeySituations[2][pKey]] :
                                pKey === 'effectiveDate' ? moment().format('YYYY-MM-DD') :
                                    copyModel[key1][pKey];
                            let initialDate = getValueField("vigenciaPolizaDesde",formResponses)
                            if(pKey==='effectiveDate' && initialDate){
                                initialDate = initialDate.split(' ')[0]
                                kValue = moment(initialDate,["DD/MM/YYYY", "YYYY-MM-DD"]).format('YYYY-MM-DD')
                            }
                            if (pKey === 'currencyId') {
                                kValue = getValueField('monedaId', formResponses);
                            }
                            newPolicy[pKey] = kValue;
                        });
                        copyModel[key1] = newPolicy;
                        break;
                    case 'situations':
                        const situations = [];
                        const newInsureds = insureds && insureds.length > 0 ? insureds : [{ type: 'T' }];
                        const situationsKeys = Object.keys(copyModel[key1][0] ? copyModel[key1][0] : {});
                        newInsureds && newInsureds.forEach((insured, index) => {
                            const newInsured = {};
                            situationsKeys && situationsKeys.forEach(sKey => {
                                const value = sKey === "riskNumber" ? index + 1 : (insured.type === "T" || sKey === "zipCodeId") &&
                                    getValueField(newKeySituations[0][sKey], formResponses);
                                const newKey = newKeySituations[1][sKey] ? newKeySituations[1][sKey] : sKey;
                                const newValue = value ? value : insured[newKey] ? insured[newKey] : copyModel[key1][0][sKey];
                                newInsured[sKey] = sKey !== "birthdate" ? newValue :
                                    moment(newValue, ["DD/MM/YYYY", "YYYY-MM-DD"]).format('YYYY-MM-DD');
                            });
                            situations.push(newInsured);
                        });
                        copyModel[key1] = situations;
                        break;
                    case 'coverages':
                        copyModel[key1] && copyModel[key1].forEach((cove, index) => {
                            const coverage = formResponses && formResponses.find(x => x.code === cove.coverageId);
                            const additionals = ['TEV', 'FHM'];
                            const indexC = coverage && coverage.index >= 0 && Number(coverage.index) >= 0 ? Number(coverage.index) : 0
                            let value = coverage && coverage.value > 0 ? coverage.value : coverage && coverage.index >= 0 ? coverage.subLimit : 0;
                            const indexAdditionals = formResponses.findIndex(x => x.key === 'aditionals');
                            const valueR = coverage && !coverage.input && getSublimitOrValue(coverage, formResponses);
                            const isAdditional = additionals.includes(coverage && coverage.typeCoverage);
                            const validateAdditional = ((indexAdditionals === -1) || formResponses[index] && formResponses[indexAdditionals].active && formResponses[indexAdditionals].active[coverage && coverage.typeCoverage]);
                            const valueOptionalSelect = coverage && coverage.input ? value : valueR;
                            value = valueOptionalSelect || valueR;
                            value = isAdditional ? validateAdditional ? valueR : 0 : value;
                            copyModel[key1][index].insuredSum = form && cove && cove.coverageId === '5101' && Number(form.getFieldValue('5101')) === 0 ? 0 : value

                        });
                        copyModel[key1] = copyModel[key1].filter(cov => {
                            let validate = true
                            const coverageIndex = formResponses && formResponses.findIndex(x => x.code === cov.coverageId);
                            const coverage = formResponses[coverageIndex];
                            const indexC = coverage && coverage.index >= 0 && Number(coverage.index) >= 0 ? Number(coverage.index) : 0
                            const currencyLimit = coverage && coverage.currencyLimit && coverage.currencyLimit[indexC];
                            const value = cov.insuredSum
                            validate = currencyLimit && currencyLimit.insuredSumCriteria && !value ? false : !value && currencyLimit && !currencyLimit.insuredSumCriteria && coverage.input ? false : validate
                            validate = value ? true : cov && cov.coverageId && currencyLimit && !currencyLimit.insuredSumCriteria && !coverage.input
                            validate = coverage && (Number(coverage.value) === 0) && cov.coverageId !== "4C08" ? false : validate
                            if (currencyLimit && currencyLimit.insuredSumCriteria?.dependencies && currencyLimit.insuredSumCriteria?.formula.includes('EQ') && form) {
                                currencyLimit.insuredSumCriteria.dependencies.forEach((dep) => {
                                    if (Number(form.getFieldValue(dep)) === 0) {
                                        validate = false
                                    }
                                })
                            }
                            return validate
                        });

                        break;
                    default:
                        typeof copyModel[key1] === 'object' && Object.keys(copyModel[key1]).forEach(key2 => {
                            if (typeof copyModel[key1][key2] === 'object') {
                                copyModel[key1][key2] && Object.keys(copyModel[key1][key2]).forEach(key3 => {
                                    const personType = copyModel[key1][key2]['personType'] === 'personaMoral' ? 'Moral' : '';
                                    const personTypeInsured = formResponses.find(x => x.key === 'tipoDePersonaAsegurado')?.value === 'personaMoral' ? 'Moral' : 'Fisica';
                                    let keyField1 = key1 === 'client' ? `${personType && NewKeysContratanteMoral[key3] ? NewKeysContratanteMoral[key3] :
                                        NewKeysContratante[key3] || key3}Contratante${key3 === 'rfc' ? personType : ''}` :
                                        key1 === 'insured' ? `${personTypeInsured === 'Moral' && NewKeysContratanteMoral[key3] ? NewKeysContratanteMoral[key3] :
                                            NewKeysContratante[key3] || key3}${key3 === 'rfc' && personTypeInsured === 'Moral' ? personTypeInsured : ''}${key3 === 'rfc' ? '' : 'Asegurado'}` :
                                            key1 === 'preferentialBeneficiary' ? newKeysPreferente[key3] ? newKeysPreferente[key3] : key3 :
                                                NewKeys[key3] || key3;
                                    keyField1 = (key3 === 'taxReformId' || key3 === 'receiverCode') ? MapKeysUrl[key3] : keyField1;
                                    let fieldVal = formResponses.find((item) => item.key === keyField1);
                                    let valueFieldVal = key3 === 'birthdate' && key1 === 'preferentialBeneficiary' ? moment().format('YYYY-MM-DD') :
                                        fieldVal && key3 === 'birthdate' ? moment(fieldVal.value, ["DD/MM/YYYY", "YYYY-MM-DD"]).format('YYYY-MM-DD') :
                                            key3 === 'typeLegalId' && key1 === 'preferentialBeneficiary' ? '2' :
                                                key1 !== 'preferentialBeneficiary' && key3 === 'typeLegalId' ? personType ? '2' : '1' :
                                                    fieldVal && fieldVal.type === 'select' && (fieldVal.data.values || fieldVal.valuesResponse) && IdsKeysDescription[key3] ?
                                                        getDescriptionSelect(fieldVal.value, fieldVal.data.values || fieldVal.valuesResponse) : fieldVal && fieldVal.value ? fieldVal.value : copyModel[key1][key2][key3];
                                    if (fieldVal && !fieldVal.value && keyField1 === 'estadoAsegurado') {
                                        fieldVal = formResponses.find((item) => item.key === `copy${keyField1}`);
                                        valueFieldVal = fieldVal && fieldVal.value ? fieldVal.value : copyModel[key1][key2][key3];
                                    }
                                    let value = getConvert(valueFieldVal, typeof copyModel[key1][key2][key3]);
                                    if (key3 === 'rfc' && !value && form && key1 !== 'preferentialBeneficiary') {
                                        value = getValueField(keyField1, formResponses) || '';
                                    } else if (key3 === 'gender' && !value && form) {
                                        value = 'E';
                                    }
                                    copyModel[key1][key2][key3] = value;
                                });
                            } else {
                                const keyField = NewKeys[key2] || key2;
                                const field = formResponses.find((x) => x.key === keyField);
                                let valueField = field && field.type === 'select' && (field.data.values || field.valuesResponse) && IdsKeysDescription[key2] ?
                                    getDescriptionSelect(field.value, field.data.values || field.valuesResponse) : field && field.value ? field.value : copyModel[key1][key2];
                                if (keyField === 'claveTipoFamilia') {
                                    const allCoverage = formResponses.find((x) => x.key === 'coberturas') ? formResponses.find((x) => x.key === 'coberturas').value : null;
                                    const coverageGF = allCoverage && allCoverage.length > 0 &&
                                        allCoverage.find(xc => xc.claveCobertura === "9198");
                                    valueField = coverageGF && coverageGF.checks ? coverageGF.checks : copyModel[key1][key2];
                                }
                                if (!field && keyField === 'stateId') {
                                    let fieldVal = formResponses.find((item) => item.key === `copyestadoAsegurado`);
                                    valueField = fieldVal && fieldVal.value ? fieldVal.value : valueField;
                                }
                                const value = getConvert(valueField, typeof copyModel[key1][key2]);
                                copyModel[key1][key2] = value;
                            }
                        });
                        break;
                }
            });
            return copyModel
        } else {
            return body;
        }
    }
    else {
        return body;
    }
}
const getPrice = (price) => {
    return price && Number(price.toString().replace(/[^0-9]/g, ''));
}

const fieldRFC = [
    'identificadorPersona',
    'identificadorPersonaMoral',
    'identificadorPersonaContratanteMoral',
    'identificadorPersonaContratante'
]

const IdsKeysDescription = {
    coloniaDescripcion: true,
    colonyDescription: true,
    municipioDescripcion: true,
    ciudadDescripcion: true,
    estadoDescripcion: true,
    paisDescripcion: true,
    descripcionOcupacion: true,
    descripcionNacionalidad: true,
    tipoDeIdentificacionEntregada: true,
    parentescoDescripcion: true,
    generoDescripcion: true,
    paisResideFiscalmente: true,
    estadoCivilDescripcion: true,
    generoMascotDescripcion: true,
    tipoMascotaDescripcion: true,
    zoneDescription: true
}


export const newKeySituations = [
    {
        kinship: 'type',
        name: 'nombre',
        birthdate: 'fechaNacimiento',
        phoneNumber: "telefono",
        gender: "genero",
        email: 'email',
        zipCodeId: 'codigoPostal'
    },
    {
        kinship: 'type',
        birthdate: 'age',
        zipCodeId: 'codigoPostal'
    },
    {
        officeId: 'oficinaId',
        productId: 'ramoId',
        atrGroupId: 'atrGrupoId',
        atrSubgroupId: 'atrSubgrupoId',
        atrProfileRateId: 'atrPerfilTarifaId',
        atrPointSaleId: 'atrPuntoVentaId',
        userId: 'usuarioId',
        name: 'name',
        email: 'email'
    }
];

const newKeysPreferente = {
    equipment: 'equipoInmueblePreferente',
    businessName: 'razonSocialPreferente',
}


const NewKeys = {
    numberFloors: 'cantidadPisos',
    equipment: 'equipoInmueblePreferente',
    businessName: 'razonSocialPreferente',
    businessActivityId: 'giro',
    propertyTypeId: 'tipoInmueble',
    constructionTypeId: 'tipoConstruccion',
    zipCodeId: 'codigoPostal',
    businessNamePdf: 'nombreEmpresa',
    quoteName: 'nombreEmpresa',
    colonyDescription: 'colonia',
    currencyId: 'monedaId',
    name: "nombre",
    email: 'email',
    phone: 'telefono',
    rfc: 'identificadorPersona',
    firmaElectronica: 'eFirma',
    telefonoClaveLada: 'telefonoExtranjero',
    otraNacionalidad: 'otrasNacionalidades',
    paisResideFiscalmente: 'paisResidenteFiscal',
    paisResideFiscalmenteDescripcion: 'paisResidenteFiscal',
    numIdExtranjero: 'nIdentificacionEnElExtranjero',
    ingresoMensual: 'ingresosMensuales',
    paisNacimiento: 'pais',
    calleNumeroExt: 'nExterior',
    calleNombre: 'direccion',
    numeroDepartamentoInterno: 'calleNumInterior',
    codigoPostalId: 'codigoPostal',
    coloniaId: 'coloniaAsegurado',
    estadoId: 'estadoAsegurado',
    paisId: 'pais',
    municipioId: 'municipioAsegurado',
    ciudadId: 'ciudadAsegurado',
    ocupacion: 'claveOcupacion',
    tipoJuridicoIdContratante: 'tipoDePersonaContratante',
    coloniaDescripcion: 'coloniaAsegurado',
    municipioDescripcion: 'municipioAsegurado',
    ciudadDescripcion: 'ciudadAsegurado',
    estadoDescripcion: 'estadoAsegurado',
    paisDescripcion: 'pais',
    descripcionOcupacion: 'claveOcupacion',
    descripcionNacionalidad: 'nacionalidad',
    parentescoDescripcion: 'parentesco',
    generoDescripcion: 'genero',
    folioFromPartner: 'folio',
}

const NewKeysUrl = {
    codigoPostalContratante: 'codigoPostal',
    identificadorPersonaContratante: 'identificadorPersona',
    identificadorPersonaContratanteMoral: 'identificadorPersona',
    codigoPostalAsegurado: 'codigoPostal',
    identificadorPersona: 'identificadorPersona',
    identificadorPersonaMoral: 'identificadorPersona',
    cpFacturacion: 'codigoPostal'
}

const MapKeysUrl = {
    apePaterno: 'primerApellido',
    apeMaterno: 'segundoApellido',
    RFC: 'identificadorPersona',
    primerNombreContratante: 'razonSocialContratante',
    fechaNacimientoContratante: 'fechaDeConstitucionContratante',
    propertyType: 'tipoInmueble',
    businessActivity: 'giro',
    currency: 'monedaId',
    sumInsuredCivilLiability: '5101',
    sumInsuredContents: '1030',
    sumInsuredInternalDamage: '4001',
    sumInsuredMoneyAndStock: '4A03',
    sumInsuredProperty: '1001',
    sumInsuredTheft: '4301',
    zipCode: 'codigoPostal',
    earthquake: 'TEV',
    hydrometeorological: 'FHM',
    taxReformId: 'regimenFiscalContratante',
    receiverCode: 'cpFacturacion',
    streetName: 'direccionAsegurado',
    streetNumberExt: 'nExteriorAsegurado'
}

const NewKeysContratante = {
    personType: 'tipoDePersona',
    rfc: 'identificadorPersona',
    businessName: 'razonSocial',
    name: 'primerNombre',
    secondName: 'segundoNombre',
    surname: 'primerApellido',
    secondSurname: 'segundoApellido',
    birthdate: 'fechaNacimiento',
    gender: 'sexo',
    phoneNumber: 'telefonoCelular',
    email: 'email',
    streetName: 'direccion',
    streetNumberExt: 'nExterior',
    internalDepartmentNumber: 'calleNumInterior',
    zipCodeId: 'codigoPostal',
    colonyId: 'colonia',
    colonyDescription: 'colonia',
    municipalityId: 'municipio',
    stateId: 'estado'
}

const NewKeysContratanteMoral = {
    birthdate: 'fechaDeConstitucion',
    name: 'razonSocial',
    secondName: ' ',
    surname: ' ',
    secondSurname: ' ',
}

export const InsuredKeys = [
    { M: 'Femenino', H: 'Masculino' },
    { M: 'Hija', H: 'Hijo' },
    { T: 'Titular', C: 'Cónyuge', H: 'Hija (o)' },
    { parentescoAsegurado: 'type', generoAsegurado: 'gender', fechaNacimientoAsegurado: 'age' },
    { T: 'titular', C: 'adicional', H: 'adicional' }
];

export function getDescriptionSelect(key, valuesResponse) {
    const description = valuesResponse && valuesResponse.find(item => (item.clave || item.value || item.key) === key);
    return description && (description.descripcion || description.description) ? (description.descripcion || description.description) : description && description.label ? description.label : '';
}

export function getConvert(value, type) {
    switch (type) {
        case "number":
            value = Number(value);
            break;
        case "string":
            value = String(value);
            break;
        case "date":
            value = moment(value).format('YYYY-MM-DD');
    }
    return value;
}

export function getKeys(current) {
    return current && current.newItems && current.newItems.map(value => value.key);
}

export function formatPrice(priceValue) {
    let priceparts = [];
    if (priceValue) {
        const priceSplit = priceValue.toString().split(".");
        const transformPrice = priceSplit[0];
        priceparts.push(transformPrice);
        if (priceSplit.length > 1 && priceSplit[1]) {
            priceparts.push(priceSplit[1]);
        }
    }
    var newPrice = Math.round(Number(priceparts.join(".")) * 100) / 100;
    return `$ ${newPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

export function getDependencyValue(current, key, value, showField) {
    const conditionalFields = current && current.newItems
        .filter(valu => valu?.conditional?.when === key);

    conditionalFields && conditionalFields.length > 0 &&
        conditionalFields.forEach(conditionalField => {
            getDependencyValue(current, conditionalField.key,
                conditionalField.value ? conditionalField.value : '', showField);
            const show = conditionalField.conditional.eq === value ?
                !conditionalField.conditional.show : conditionalField.conditional.show;
            showField.push({ [conditionalField.key]: show });
        });
    return showField;
}

export function getValueField(key, formResponses) {
    const field = formResponses.find(value => value.key === key);
    return field && field.value ? field.value : '';
}

export function getInfoField(key, stepKey, components) {
    const fields = components && components.find(comp => comp.title === stepKey);
    const field = fields && fields.components.find(fd => fd.key === key);
    return field ? field : {};
}

export function getPercentage(item) {

    const value = String((item.current * 100) / item.quantity);

    return item.active ? value && value !== 'NaN' ? value :
        item.current === 0 && item.quantity === 0 ? 100 : 100 : 0;
}

export function replaceAtrBody(body, tokenInfo) {
    const bodyKeys = Object.keys(body);
    const copyModel = { ...body };
    bodyKeys.forEach(key => {
        if (Object.hasOwnProperty.call(tokenInfo, key)) {
            copyModel[key] = tokenInfo[key];
        }
    });
    return copyModel;
}


export function getSidebarData(data) {
    const sidebarData = data.find(x => x.key === 'sidebarData');
    return sidebarData ? [sidebarData] : null;
}

export function getPriceToShow(coverages) {
    let total = 0;
    coverages && coverages.length > 0 && coverages.forEach(coverage => {
        total = total + coverage.totalAmount;
    });
    return total + (total * Number(process.env.REACT_APP_TAX_PERCENTAGE));
}

export function filterObject(obj, value) {
    return Object.fromEntries(Object.entries(obj).
        filter(([key]) => key.includes(value) || value === 'Asegurado' && key.includes('identificadorPersona')));
}



export function getNewObject(fieldsValues, type, formResponses) {


    const typeInsured = fieldsValues[`tipoDePersona${type}`] || getValueField(`tipoDePersona${type}`, formResponses);
    const objectKeys = {
        rfc: `identificadorPersona${type === 'Contratante' ? typeInsured === 'personaMoral' ? 'ContratanteMoral' : 'Contratante' : typeInsured === 'personaMoral' ? 'Moral' : ''}`,
        name: typeInsured === 'personaFisica' ? `primerNombre${type}` : `razonSocial${type}`,
        secondName: typeInsured === 'personaFisica' ? `segundoNombre${type}` : ``,
        surname: `primerApellido${type}`,
        secondSurname: `segundoApellido${type}`,
        birthdate: typeInsured === 'personaFisica' ? `fechaNacimiento${type}` : `fechaDeConstitucion${type}`,
        type: `tipoDePersona${type}`
    }

    let newObj = fieldsValues ? {
        rfc: fieldsValues[objectKeys['rfc']] || getValueField(objectKeys['rfc'], formResponses),
        name: fieldsValues[objectKeys['name']] || getValueField(objectKeys['name'], formResponses),
        secondName: fieldsValues[objectKeys['secondName']] || getValueField(objectKeys['secondName'], formResponses),
        surname: fieldsValues[objectKeys['surname']] || getValueField(objectKeys['surname'], formResponses),
        secondSurname: fieldsValues[objectKeys['secondSurname']] || getValueField(objectKeys['secondSurname'], formResponses),
        birthdate: moment(fieldsValues[objectKeys['birthdate']] || getValueField(objectKeys['birthdate'], formResponses), ["DD/MM/YYYY", "YYYY-MM-DD"]).format('YYYY-MM-DD'),
        type: fieldsValues[objectKeys['type']] || getValueField(objectKeys['type'], formResponses)
    } : {}

    return newObj;
}

export function validateForm(fields, form) {
    return form.validateFields(fields, () => { }).then(() => {
        return true;
    }).catch(() => { return false })
}

export function encrypt(data, key) {
    const ciphertext = CryptoJS.AES.encrypt(data, key).toString();
    const dataBase64 = Buffer.from(ciphertext).toString('base64')
    return dataBase64;
}

export function decrypt(data, key) {
    return CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
}

export const getDate = (value) => {
    return moment().diff(moment(value, ["DD/MM/YYYY", "YYYY-MM-DD"]), 'years');
}

export function validateDiff(type, dateField, insureds, insuredAge) {
    let validate = false
    const difference = dateField && dateField.properties && dateField.properties.difference;
    if (difference && Number(difference) !== 0 && type === "H") {   // si la diferencia es 0 se desactiva la validación -> false -> no arroja fecha inválida
        const holderInfo = insureds.find(x => x.type === "T");
        const holderAge = getDate(holderInfo && holderInfo.age);
        validate = (holderAge - insuredAge) < Number(difference);
    }
    return (validate);
}


export const fieldsFisica = {
    "primerNombre": true,
    "segundoNombre": true,
    "primerApellido": true,
    "segundoApellido": true,
}

export function validateIsBefore(persistence) {
    let result = {};
    if (persistence && persistence.payment && persistence.urlPayment && persistence.urlPayment.length > 0) {
        const statusFolio = persistence.configuracion && persistence.configuracion.estadoFlujo;
        const objPayment = persistence.payment[persistence.payment.length - 1];
        const statusPayment = objPayment.payment.status || '';
        const url = persistence.urlPayment[persistence.urlPayment.length - 1];
        result = { url: url.urlRedirect, isBefore: statusFolio === 'Pendiente' ? true : statusPayment && statusPayment === 'canceled' ? false : url && url.validity && moment().isBefore(moment(url.validity)) };
    }
    return result;
}


export const fieldToClear = [
    "primerNombreAsegurado",
    "segundoNombreAsegurado",
    "primerApellidoAsegurado",
    "segundoApellidoAsegurado",
    "sexoAsegurado",
    "fechaNacimientoAsegurado",
    "razonSocialAsegurado",
    "fechaDeConstitucionAsegurado",
    "primerNombreContratante",
    "segundoNombreContratante",
    "primerApellidoContratante",
    "segundoApellidoContratante",
    "sexoContratante",
    "fechaNacimientoContratante",
    "telefonoCelularContratante",
    "direccionContratante",
    "nExteriorContratante",
    "calleNumInteriorContratante",
    "emailContratante",
    "razonSocialContratante",
    "fechaDeConstitucionContratante",
];
